import Hero from "@/components/Hero";
import WhySection from "@/components/WhySection";
import AboutFounder from "@/components/AboutFounder";
import ThreePillars from "@/components/ThreePillars";
import HandcraftedPurpose from "@/components/HandcraftedPurpose";
import ScentCollection from "@/components/ScentCollection";
import CombosSection from "@/components/CombosSection";
import MembershipGateway from "@/components/MembershipGateway";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <WhySection />
      <AboutFounder />
      <ThreePillars />
      <HandcraftedPurpose />
      <ScentCollection />
      <CombosSection />
      <MembershipGateway />
    </div>
  );
}
